import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, CircularProgress } from '@mui/material';

const primaryColor = '#5757b0';
const hoverColor = '#7777d0';

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?"
}) => {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        }
      }}
    >
      <DialogTitle sx={{ color: primaryColor, fontWeight: 'bold' }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: '16px' }}>
        <Button onClick={onClose} disabled={isLoading} sx={{ color: '#666' }}>
          Cancel
        </Button>
        <Button 
          onClick={onConfirm}
          disabled={isLoading}
          variant="contained"
          sx={{ 
            backgroundColor: primaryColor,
            '&:hover': {
              backgroundColor: hoverColor,
            }
          }}
        >
          {isLoading ? <CircularProgress size={20} color="inherit" /> : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
